import { useMemo } from "react";
import type { SortKey } from "../types";
import type { UsersTableVariant } from "../types";

export const useUsersTableMobileOptions = (variant: UsersTableVariant) => {
    return useMemo(() => {
        if (variant === "users") {
            return [
                { key: "listingsCount" as const, label: "Объявления" },
                { key: "createdAt" as const, label: "Создан" },
                { key: "name" as const, label: "Имя" },
                { key: "email" as const, label: "Email" },
            ] satisfies { key: SortKey; label: string }[];
        }

        return [
            { key: "expiresAt" as const, label: "Срок" },
            { key: "listingsCount" as const, label: "Объявления" },
            { key: "name" as const, label: "Имя" },
            { key: "email" as const, label: "Email" },
        ] satisfies { key: SortKey; label: string }[];
    }, [variant]);
};
